<template>
  <layout menu-item="1">
    <div class="dashboard-container">
      <dashboard-city-ranking class="element"/>
      <post-score class="element"/>
    </div>

  </layout>
</template>

<script>
  import DashboardCityRanking from "./DashboardCityRanking";
  import PostScore from "./PostScore";
  import Utils from "@/Utils";

  export default {
    name: "dashboard",
    components: {PostScore, DashboardCityRanking},
    data() {
      return {
        isDev: Utils.isDevEnvironment()
      }
    }
  }
</script>

<style scoped>
  .dashboard-container {
    padding: 1rem;
  }

  .element {
    float: left;
    margin: 0.5rem;
    width: 25rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue